export default __webpack_public_path__ + "static/media/SFicon.c2d57b9a.png";